module.exports = __webpack_public_path__ + "img/20200511154830728.a5eb6fbd.png";